import { Component, OnInit } from '@angular/core';
import {ListeContact} from '../../../../../model/liste/ListeContact';
import {ListeContactContact} from '../../../../../model/liste/ListeContactContact';
import {Contact} from '../../../../../model/contact/Contact';
import {ActivatedRoute, Router} from '@angular/router';
import {FormatIntranetShareService} from '../../../../../service/partage/prototype/FormatIntranetShareService';
import {DialogueShareService} from '../../../../../service/partage/utilitaire/DialogueShareService';
import {NgxSpinnerService} from 'ngx-spinner';
import {ListeContactService} from '../../../../../service/interne/contact/ListeContactService';
import {ContactService} from '../../../../../service/interne/contact/ContactService';
import {Parution} from '../../../../../model/parution/Parution';
import {ListeOrganisation} from '../../../../../model/liste/ListeOrganisation';
import {ContactOrganisation} from '../../../../../model/contact/ContactOrganisation';
import {Suivi} from '../../../../../model/suivi/Suivi';
import {ListeOrganisationOrganisation} from '../../../../../model/liste/ListeOrganisationOrganisation';

@Component({
  selector: 'app-escal-liste-contact-fiche',
  templateUrl: './escal-liste-contact-fiche.component.html',
  styleUrls: ['./escal-liste-contact-fiche.component.scss'],
  providers: [ ListeContactService, ContactService ]
})
export class EscalListeContactFicheComponent implements OnInit {

  private sub: any;
  listeContact: ListeContact;
  auteurAncienId: number;
  contactsAssocies: Array<Contact>;
  assosListeContact: Array<ListeContactContact>;
  maxPage: number;
  curentPage: number;
  total: number;
  fakeArray: Array<any>;
  commentaires: string;
  nbCaracteres: number;
  afficher: string;
  infosContacts: Array<any> = [];
  listeDesassocier: Array<any> = [];
  vue: string;
  constructor(private listeContactService: ListeContactService, private route: ActivatedRoute,
              public formatIntranetShareService: FormatIntranetShareService, private contactService: ContactService,
              private dialogueShareService: DialogueShareService, private router: Router, private spinner: NgxSpinnerService) { }

  ngOnInit() {
    this.auteurAncienId = 0;
    this.curentPage = 1;
    this.commentaires = '';
    this.nbCaracteres = 0;
    this.afficher = 'moins';
    this.infosContacts = [];
    this.vue = 'RP';
    this.sub = this.route.params.subscribe(params => {
      this.listeContactService.getListeContactDetails(params.id)
        .then((listeContact) => {
          this.listeContact = listeContact as ListeContact;
          // récupérer l'ancien id de l'auteur pour le lien vers sa fiche intranet
          if (this.listeContact.auteur != null) {
            this.listeContactService.getAncienIdAuteur(this.listeContact.id).then((retour) => {
              if (retour !== 0) {
                this.auteurAncienId = retour;
              }
            });
          }
          // adapter l'affichage du commentaire si trop long
          if (this.listeContact.commentaires != null) {
            this.nbCaracteres = this.listeContact.commentaires.length;
            this.commentaires = this.listeContact.commentaires.substr(0, 100);
          }
          this.listeContactService.getAllAssosListeContact(this.listeContact.id).then(conts => {
            this.total = conts['hydra:totalItems'];
            this.getMaxPage(this.total);
            this.fakeArray = new Array(this.maxPage);
          });
          let dizaine;
          dizaine = Number(this.curentPage) - 1;
          if (dizaine != 0) {
            dizaine = dizaine + '0';
          }
          this.listeContactService.getDetailsContactsListe(this.listeContact.id, dizaine).then((contacts) => {
            this.contactsAssocies = contacts as Array<Contact>;
            this.getInfosContacts();
          });
        });
    });
  }

  async getInfosContacts() {
    this.infosContacts = [];
    let infoContact;
    let adresses;
    let telephones;
    let supports;
    let organisations;
    let adressePresente;
    let telPresent;
    for (const contactAsso of this.contactsAssocies) {
      infoContact = {};
      adresses = [];
      telephones = [];
      supports = [];
      organisations = [];
      infoContact.id = contactAsso.id;
      if (contactAsso.coordonnees != null) {
        adressePresente = adresses.find(element => element === contactAsso.coordonnees.email);
        if (adressePresente === undefined && contactAsso.coordonnees.email != null && contactAsso.coordonnees.email != '') {
          adresses.push(contactAsso.coordonnees.email);
        }
        telPresent = telephones.find(element => element === contactAsso.coordonnees.premierTel);
        if (telPresent === undefined && contactAsso.coordonnees.premierTel != null && contactAsso.coordonnees.premierTel != ''
          && contactAsso.coordonnees.premierTel != '33' && contactAsso.coordonnees.premierTel != '+33') {
          telephones.push(contactAsso.coordonnees.premierTel);
        }
        telPresent = telephones.find(element => element === contactAsso.coordonnees.deuxiemeTel);
        if (telPresent === undefined && contactAsso.coordonnees.deuxiemeTel != null && contactAsso.coordonnees.deuxiemeTel != ''
          && contactAsso.coordonnees.deuxiemeTel != '33' && contactAsso.coordonnees.deuxiemeTel != '+33') {
          telephones.push(contactAsso.coordonnees.deuxiemeTel);
        }
      }
      await this.contactService.getContactSupportBycontactID(contactAsso.id).then(contactSupports => {
        if (contactSupports['hydra:member'] != null) {
          for (const contactSupport of contactSupports['hydra:member']) {
            supports.push(contactSupport.support);
            adressePresente = adresses.find(element => element === contactSupport.email);
            if (adressePresente === undefined && contactSupport.email != null && contactSupport.email != '') {
              adresses.push(contactSupport.email);
            }
            telPresent = telephones.find(element => element === contactSupport.premierTel);
            if (telPresent === undefined && contactSupport.premierTel != null && contactSupport.premierTel != ''
              && contactSupport.premierTel != '33' && contactSupport.premierTel != '+33') {
              telephones.push(contactSupport.premierTel);
            }
            telPresent = telephones.find(element => element === contactSupport.deuxiemeTel);
            if (telPresent === undefined && contactSupport.deuxiemeTel != null && contactSupport.deuxiemeTel != ''
              && contactSupport.deuxiemeTel != '33' && contactSupport.deuxiemeTel != '+33') {
              telephones.push(contactSupport.deuxiemeTel);
            }
          }
        }
      });
      await this.contactService.getContactOrganisationBy(contactAsso.id).then(contactOrganisations => {
        if (contactOrganisations['hydra:member'] != null) {
          for (const contactOrg of contactOrganisations['hydra:member']) {
            organisations.push(contactOrg.organisation);
            adressePresente = adresses.find(element => element === contactOrg.email);
            if (adressePresente === undefined && contactOrg.email != null && contactOrg.email != '') {
              adresses.push(contactOrg.email);
            }
            telPresent = telephones.find(element => element === contactOrg.premierTel);
            if (telPresent === undefined && contactOrg.premierTel != null && contactOrg.premierTel != ''
              && contactOrg.premierTel != '33' && contactOrg.premierTel != '+33') {
              telephones.push(contactOrg.premierTel);
            }
            telPresent = telephones.find(element => element === contactOrg.deuxiemeTel);
            if (telPresent === undefined && contactOrg.deuxiemeTel != null && contactOrg.deuxiemeTel != ''
              && contactOrg.deuxiemeTel != '33' && contactOrg.deuxiemeTel != '+33') {
              telephones.push(contactOrg.deuxiemeTel);
            }
          }
        }
      });
      infoContact['adresses'] = adresses;
      infoContact['telephones'] = telephones;
      infoContact['supports'] = supports;
      infoContact['organisations'] = organisations;
      await this.listeContactService.getDernierSuiviContact(contactAsso.id).then(suivi => {
        infoContact.suivi = suivi['hydra:member'][0] as Suivi;
      });
      this.infosContacts.push(infoContact);
    }
  }

  getMaxPage(nbElement) {
    this.maxPage = Math.trunc(nbElement / 10);
    if (nbElement % 10 !== 0) {
      this.maxPage = this.maxPage + 1;
    }
  }

  changerAffichage() {
    if (this.afficher === 'plus') {
      this.commentaires = this.listeContact.commentaires.substr(0, 100);
      this.afficher = 'moins';
    } else {
      this.commentaires = this.listeContact.commentaires;
      this.afficher = 'plus';
    }
  }

  accesPage() {
    this.infosContacts = [];
    let dizaine;
    dizaine = Number(this.curentPage) - 1;
    if (dizaine != 0) {
      dizaine = dizaine + '0';
    }
    this.listeContactService.getDetailsContactsListe(this.listeContact.id, dizaine).then((contacts) => {
      this.contactsAssocies = contacts as Array<Contact>;
      this.getInfosContacts();
    });
  }

  pageMoins() {
    this.infosContacts = [];
    if (this.curentPage > 0) {
      this.curentPage = Number(this.curentPage) - 1;
      let dizaine;
      dizaine = Number(this.curentPage) - 1;
      if (dizaine != 0) {
        dizaine = dizaine + '0';
      }
      this.listeContactService.getDetailsContactsListe(this.listeContact.id, dizaine).then((contacts) => {
        this.contactsAssocies = contacts as Array<Contact>;
        this.getInfosContacts();
      });
    }
  }

  pagePlus() {
    this.infosContacts = [];
    if (this.curentPage < this.maxPage) {
      this.curentPage = Number(this.curentPage) + 1;
      let dizaine;
      dizaine = Number(this.curentPage) - 1;
      if (dizaine != 0) {
        dizaine = dizaine + '0';
      }
      this.listeContactService.getDetailsContactsListe(this.listeContact.id, dizaine).then((contacts) => {
        this.contactsAssocies = contacts as Array<Contact>;
        this.getInfosContacts();
      });
    }
  }

  supprimerListe() {
    this.dialogueShareService.addDialogue('Supprimer la liste ?', () => {
      this.spinner.show();
      // supprimer les associations avant de supprimer la liste
      // pour chaque contact associé on supprime l'asso
      this.assosListeContact = [];
      this.listeContactService.getAllAssosListeContact(this.listeContact.id).then(async (assos) => {
        this.assosListeContact = assos['hydra:member'] as Array<ListeContactContact>;
        if (this.assosListeContact != null) {
          for (const assosListeContact1 of this.assosListeContact) {
            await this.listeContactService.supprimerAssoListeContact(assosListeContact1.id).then(() => {
            });
          }
        }
        // supprimer liste dans la base intranet
        await this.listeContactService.supprimerImportListeContactIntranet(this.listeContact.ancienId)
          .then(async () => {
            // supprimer liste d'escalnet
            await this.listeContactService.supprimerListeContact(this.listeContact.id).then((liste) => {
              this.spinner.hide();
              this.router.navigate(['/escal/listes/contact']);
              this.dialogueShareService.addDialogue('La liste a bien été supprimée');
            });
          });
      });
    });
  }

  ajouterListeDesassocier(contactId) {
    let contactPresent;
    if (contactId != 0) {
      contactPresent = this.listeDesassocier.find(element => element == contactId);
      if (contactPresent === undefined) {
        // si pas dans la liste, on l'ajoute
        this.listeDesassocier.push(contactId);
      } else {
        // si dans la liste, on l'enlève
        this.listeDesassocier = this.listeDesassocier.filter(element => element != contactId);
      }
    }
  }

  async supprimerAssociation() {
    if (this.listeDesassocier.length > 0) {
      this.dialogueShareService.addDialogue('Désassocier ces contacts ?', async () => {
        for (const contactId of this.listeDesassocier) {
          await this.listeContactService.getOneAssoContactListe(this.listeContact.id, contactId).then(async (asso) => {
            if (asso['hydra:member'][0] != undefined && asso['hydra:member'][0] != null) {
              await this.contactService.deleteContactAssoIntranet('liste', asso['hydra:member'][0].id).then(async () => {
                await this.listeContactService.supprimerAssoListeContact(asso['hydra:member'][0].id).then(async () => {
                });
              });
            }
          });
        }
        await this.dialogueShareService.addDialogue('Le(s) contact(s) ont bien été désassociés');
        await this.ngOnInit();
      });
    } else {
      this.dialogueShareService.addDialogue('Aucun contact sélectionné');
    }
  }

  changerVue() {
    if (this.vue == 'RP') {
      this.vue = 'commerciale';
    } else if (this.vue == 'commerciale') {
      this.vue = 'RP';
    }
  }

}
